var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import Modal from "../Layout/Modal";
import { Translate } from "../I18N";








export const SuggestionAcceptanceModal = ({
  isOpen,
  propertyType,
  onClose,
  onAccept
}) => {
  const [allLanguages, setAllLanguages] = useState(true);
  return /*#__PURE__*/(
    _jsx(Modal, { isOpen: isOpen, type: "content", className: "suggestion-acceptance-modal" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h1", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Confirm suggestion acceptance"))), /*#__PURE__*/


    _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
    _jsx("label", { className: "language-checkbox" }, void 0,
    propertyType !== 'date' ? /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("input", {
      type: "checkbox",
      checked: allLanguages,
      onChange: (e) => setAllLanguages(e.target.checked) }), "\xA0", /*#__PURE__*/


    _jsx(Translate, {}, void 0, "Apply to all languages")) : /*#__PURE__*/


    _jsx(Translate, {}, void 0, "This will update the entity across all languages"))), /*#__PURE__*/



    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn btn-default cancel-button",
      "aria-label": "Close acceptance modal",
      onClick: onClose }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")), /*#__PURE__*/

    _jsx("button", {
      type: "button",
      className: "btn confirm-button btn-success",
      onClick: () => onAccept(allLanguages) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Confirm")))));




};